export default __webpack_public_path__ + "static/media/profile.fbae0091.jpeg";